import React, {useCallback, useEffect, useRef} from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { SpaceDetail } from "interfaces/space";
import { DetailsMenu } from "./SpaceDetailsMenu";
import { useTranslate } from "@pankod/refine-core";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { spaceDetailConstants } from "constants/spaceDetailConstants";
import { scrollToTop } from "utils/scroll";
import { spaceActions } from "store/space";
import { Focusable } from "components/Focusable";
import SpaceDocumentsForm from "./documents/SpaceDocumentsForm";

interface SpaceDetailsDocumentsProps {
    spaceDetail: SpaceDetail
    onScrollApplied: (item: DetailsMenu) => void
}

const SpaceDetailsDocuments: React.FC<SpaceDetailsDocumentsProps> = (props) => {

    const {spaceDetail, onScrollApplied} = props
    const t = useTranslate()
    const header = t('updateSpace.menuDocuments')

    const documentsRef = useRef<HTMLElement>(null)

    const dispatch = useAppDispatch()
    const currentFocusField = useAppSelector(state => state.space.currentFocusId)
    const shouldFocus = useAppSelector(state => state.space.shouldFocus)

    const focusCurrentField = useCallback(() => {
        if (shouldFocus) {
            switch (currentFocusField) {
                case spaceDetailConstants.documents:
                    scrollToTop(documentsRef, spaceDetailConstants.barOffset)
                    dispatch(spaceActions.setShouldFocus(false))
                    onScrollApplied(DetailsMenu.GeneralInfo)
                    break;
            }
        }
    }, [currentFocusField, dispatch, onScrollApplied, shouldFocus])

    //Requires empty dep array to only run once
    useEffect(() => {
        setTimeout(focusCurrentField, spaceDetailConstants.scrollTimeout)
    }, [])

    focusCurrentField()

    return <Box sx={{
        display: 'flex',
        flexDirection: 'column',
    }}>
        <Typography variant="headlineLarge">{header}</Typography>
        <Box sx={{pt: 6, pr: 4}}>
            <Focusable ref={documentsRef}>
                <SpaceDocumentsForm spaceDetail={spaceDetail} maxDocuments={10} minDocuments={1}/>
            </Focusable>
        </Box>
    </Box>
}

export default SpaceDetailsDocuments